import React from 'react';

export const TableSkeleton = () => (
  <div className="animate-pulse">
    <div className="hidden lg:block">
      <div className="border border-gray-200 dark:border-gray-700 rounded-xl overflow-hidden">
        <div className="bg-gray-50 dark:bg-gray-800 h-12"></div>
        {[...Array(5)].map((_, i) => (
          <div key={i} className="border-t border-gray-200 dark:border-gray-700 h-16 bg-white dark:bg-gray-900"></div>
        ))}
      </div>
    </div>
    <div className="lg:hidden space-y-4">
      {[...Array(3)].map((_, i) => (
        <div key={i} className="bg-gray-200 dark:bg-gray-800 h-32 rounded-xl"></div>
      ))}
    </div>
  </div>
);
